import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const authApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: "https://my-app-ruwaf.ondigitalocean.app/api/v1/auth/",

    prepareHeaders: (headers, { getState }) => {
      // By default, if we have a token in the store, let's use that for authenticated requests
      const token = getState().auth.token;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: "login",
        method: "POST",
        body: credentials,
      }),
    }),
    signup: builder.mutation({
      query: (credentials) => ({
        url: "register",
        method: "POST",
        body: credentials,
      }),
    }),
    forgotPassword: builder.mutation({
      query: (phoneNumber) => ({
        url: "forgotpassword",
        method: "POST",
        body: { phoneNumber },
      }),
    }),
    resetPassword: builder.mutation({
      query: ({ token, password }) => ({
        url: `resetpassword/${token}`,
        method: "PUT",
        body: { password: password },
      }),
    }),
    updatePassword: builder.mutation({
      query: ({ currentPassword, newPassword }) => ({
        url: "updatepassword",
        method: "PUT",
        body: { currentPassword, newPassword },
      }),
    }),
    protected: builder.mutation({
      query: () => "protected",
    }),
  }),
});

export const {
  useLoginMutation,
  useSignupMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useUpdatePasswordMutation,
} = authApi;
